<template>
    <div class="wrapper">
      <p class="title text-center">Security Policy Updated</p>
      <div class="content">
        <p class="text-title">Adding an extra layer of security is compulsory by the dashboard admins for you to access. To continue, please enable Two step-authentication in your VisiPoint Passport account.</p>   
      </div>
      <!-- action btns  -->
      <hr class="h-line" />
      <div class="action-btns">
        <button class="submit-btn btn btn-primary" size="md" @click="onOkay"><span>Okay</span></button>
      </div>
    </div>
  </template>
  
  <script>
  import { mapActions, mapGetters } from "vuex";
  export default {
    data() {
      return {
        isSubmitted: false,
      };
    },
    computed: {
      ...mapGetters("user", [ "getModalState", "getUserData"]),
      ...mapGetters("modal", ["getModalInfo"]),
    },
    methods: {
        ...mapActions("user", ["resetState"]),
        ...mapActions("authfack", ["fetchUserOtpAuthStatus", "sendOtpAuthCode", "updateUserOtpAuthStatus"]),
        onOkay() {
            this.$bvModal.hide('OtpAuthAppliedMessageModal');
            this.$bvModal.show('twoStepAuthenticationModal');
        },
    },
    beforeMount() {
      this.resetState();
    },
  };
  </script>
  
  <style lang="scss" scoped>

    .wrapper {
        .text-title {
            width: 416px;
            font-size: 16px;
            margin-bottom: 40px;
            text-align: center;
            color: #4A4A4A;
            font-weight: 400;
        }
        .err-wrapper {
            padding-left: 53px;
            margin-top: 2px;
        }
        .h-line{
            margin-top: 40px !important;
            margin-bottom: 24px !important;
        }

        .action-btns {
            .submit-btn {
                margin-right: 0px !important;
            }
        }
    }

  p.text-title {
    height: 83px;
    -webkit-box-align: center;
    -ms-flex-align: center;
    align-items: center;
    display: -webkit-box;
  }

</style>